<template>
    <table>
        <tr v-if="replaced_by">
            <td class="tourniquet-info-details-label"><span class="info-label">Замінений на:</span></td>
            <td>
                <TourniquetSmallInfo :info="replaced_by"/>
            </td>
        </tr>
        <tr v-if="manufacturerModels.length">
            <td colspan="2" class="separator"></td>
        </tr>
        <tr v-if="manufacturerModels.length">
            <td class="tourniquet-info-details-label" :class="{'align-top':manufacturerModels.length > 1 }"><span class="info-label">Турнікети виробника:</span></td>
            <td>
                <TourniquetSmallInfo v-for="(item, index) in manufacturerModels" :info="item" :key="index"/>
            </td>
        </tr>
    </table>
</template>
<script>

import {fetchUrl} from '../../consts';
import IconChevron from '../icons/IconChevron';
import TourniquetSmallInfo from './parts/TourniquetSmallInfo';
import {commonPageData} from '../../common';

export default {
    name: "TourniquetDetails",
    data() {
        return {
            currentId: null,
            replaced_by: null,
            manufacturerModels: []
        }
    },
    computed: {
        currentTourniquet() {
            return commonPageData.tourniquetData
        }
    },
    watch: {
        currentTourniquet() {
            this.getModelsData()
        }
    },
    methods: {
        getModelsData() {
            if(this.currentTourniquet) {
                this.replaced_by = commonPageData.tourniquetData.replaced_by;
                this.currentId = commonPageData.tourniquetData.id;

                if(this.replaced_by) {
                    document.querySelector('[data-block="order-section"]').remove();
                }
                fetch(`${fetchUrl}api/v1/manufacturers/${commonPageData.tourniquetData.manufacturer.id}`).then(response => response.json())
                    .then(manufacturerModels => {
                        this.manufacturerModels = manufacturerModels.data.filter(
                            item => item.id !== this.currentId && (this.replaced_by ? item.id !== this.replaced_by.id : true)
                        );
                    });
            }
        }
    },
    components: {
        TourniquetSmallInfo,
        IconChevron
    }
}
</script>
<style lang="scss" scoped>
@import "../../../../sass/front/helpers";

.align-top {
    padding-top: 22px;
    vertical-align: top;
}

.separator {
    height: 40px;

    @include responsive-below($md) {
        height: 20px;
    }
}
</style>
